var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tiktok_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7503"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18866"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18723"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tiktok_svg__a)",
  "data-name": "Group 18722"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.313 19.666q-.24.024-.482.025a5.23 5.23 0 0 1-4.377-2.366v8.055a5.954 5.954 0 1 1-5.954-5.954c.124 0 .246.012.368.019v2.935a3 3 0 0 0-.368-.038 3.039 3.039 0 0 0 0 6.078 3.114 3.114 0 0 0 3.161-3l.029-13.681h2.81a5.23 5.23 0 0 0 4.819 4.667v3.261",
  "data-name": "Path 27265"
}))))));
export { SvgTiktok as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok.98260707c2c497da34690817aa1bfe9b.svg";